import * as Vuex from "vuex";
import { Task, TaskExport } from "@/entities/task";
import { httpByCurrentCustomer } from "@/lib/client";
import { CallRequestInfo } from "@/services/calls/call-service";
import { handleStoreError } from "@/lib/error";

const TaksModule: Vuex.Module<TaskStoreState, {}> = {
  state: {
    listTask: [],
    taskExport: [],
  },
  getters: {
    taskTable(state) {
      return state.listTask;
    },
    taskExport(state) {
      return state.taskExport;
    },
  },
  mutations: {
    SET_TASK(state, payload: Task[]) {
      state.listTask = payload;
    },
    ADD_TASK(state, listTask: Task[]) {
      state.listTask = state.listTask.concat(listTask);
    },
    SET_TASK_EXPORT(state, taskExport: TaskExport[]) {
      state.taskExport = taskExport;
    },
  },
  actions: {
    async getAllTask({ commit }) {
      const responseTask = await httpByCurrentCustomer()
        .get("job")
        .json<Task[]>();
      if (Array.isArray(responseTask)) {
        commit("SET_TASK", responseTask);
      }
    },
    async createTask({ commit }, info: CallRequestInfo) {
      const newTask = await httpByCurrentCustomer()
        .post("recordings/queue", { json: info })
        .json<Task>()
        .catch(handleStoreError({ name: "Create task", payload: info }, true));
      commit("ADD_TASK", [newTask]);
    },
    async createTaskExport({ commit }, data: TaskExport) {
      await httpByCurrentCustomer()
        .put("scheduleExports", { json: data })
        .json<TaskExport>();
    },
    async getTaskExport({ commit }) {
      const responseTaskExport = await httpByCurrentCustomer()
        .get("scheduleExports")
        .json<TaskExport>();
      if (
        typeof responseTaskExport === "object" &&
        responseTaskExport !== null
      ) {
        commit("SET_TASK_EXPORT", responseTaskExport);
      }
    },
  },
  namespaced: true,
};

type TaskStoreState = {
  //loading: boolean;
  listTask: Task[];
  taskExport: TaskExport[];
};
export default TaksModule;
